import { useState, useEffect, useMemo, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { useSelector } from 'react-redux';
import { modalStyles } from './modalStyles';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { TextComponent } from '../../uiComponents';
import { getOtherProfiles } from '../../../store';
interface ModalComponentProps {
  data: any;
  currentTP: string;
  parentTP: string;
  close: any;
}

function ImpactAnalysisModalComponent({ data, currentTP, parentTP, close }: ModalComponentProps) {
  const [tpCopyName, settpCopyName] = useState<string>(currentTP);
  const [errorMsg, setErrorMsg] = useState<string>('A validation technical profile exists with the same Id');
  const [flag, setFlag] = useState<boolean>(false);
  const allOtherProfiles = useSelector(getOtherProfiles);
  const classes = modalStyles();
  return (
    <>
      <Modal
        disableEnforceFocus
        open={true}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            close(tpCopyName);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.boxStyle}>
          <div className={cn(classes.flexRow, classes.policyBody)}>
            <div className={classes.flexCol}>
              <div className={classes.flexRow}>
                <b className={classes.mr1}>Selected Technical Profile</b>
                <span>{currentTP}</span>
              </div>
              <div className={cn(classes.flexRow, classes.mt1)}>
                <b className={classes.mr1}>Parent Technical Profile</b>
                <span>{parentTP}</span>
              </div>
              <div className={cn(classes.flexRow, classes.mt1)}>
                <span>
                  selfAssertedProfile(s) <b>{data['dupVTP'].join(', ')}</b> has the same Validation Technical Profiles.
                  Updating existing Technical Profile would reflect in all the other places as well.
                </span>
                {/* if (_res['dupVTP'].length > 0 && promptCopyIfReq) */}
              </div>
            </div>
            <footer className={classes.footer}>
              <div className={classes.mt1}>
                {flag && (
                  <TextComponent
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      settpCopyName(e.target.value);
                      if (e.target.value === '') {
                        setErrorMsg('Should not be empty');
                      } else if (!/^[a-zA-Z0-9]+[a-zA-Z0-9_-]{0,}$/.test(e.target.value)) {
                        setErrorMsg(
                          'Should begin with an alphabet or number and can contain alphabets, numbers and the following symbols: _ -',
                        );
                      } else if (
                        Object.keys(allOtherProfiles).findIndex(
                          (el: string) => el.trim().toLowerCase() === e.target.value.trim().toLowerCase(),
                        ) >= 0
                      ) {
                        setErrorMsg('A validation technical profile exists with the same Id');
                      } else {
                        setErrorMsg('');
                      }
                    }}
                    data={{
                      style: { margin: 0, width: '300px' },
                      value: tpCopyName,
                      helperText: errorMsg,
                      error: !!errorMsg,
                      label: 'New Technical Profile Name',
                    }}
                  />
                )}
                {flag && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      setFlag(false);
                    }}
                  >
                    Cancel
                  </Button>
                )}
                {!flag && (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      close(tpCopyName);
                    }}
                  >
                    Update Existing
                  </Button>
                )}

                <Button
                  variant="contained"
                  color="primary"
                  disabled={flag && !!errorMsg}
                  onClick={() => {
                    flag ? close(tpCopyName) : setFlag(true);
                  }}
                >
                  Create a Copy
                </Button>
              </div>
            </footer>
          </div>
        </Box>
      </Modal>
    </>
  );
}

// export default withAITracking(reactPlugin, ImpactAnalysisModalComponent);
export default ImpactAnalysisModalComponent;
